import { Link } from "wouter";

const B2B_AGENCIES_GUIDE_PATH = "/b2b-marketing-agencies-london-pricing/";

export default function B2BMarketingAgenciesGuideLink({ headingLevel = "h2" }: { headingLevel?: "h2" | "h3" | "p" }) {
  const Heading = headingLevel;

  return (
    <section
      className="mt-10 rounded-xl border border-[#00D4AA]/25 bg-[#0b1725] p-5 text-white sm:p-6"
      aria-labelledby="b2b-marketing-agencies-guide-link"
    >
      <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.16em] text-[#00D4AA]">London B2B buyer guide</p>
      <Heading id="b2b-marketing-agencies-guide-link" className={headingLevel === "p" ? "promo-title font-serif text-xl" : "font-serif text-xl"}>
        Which London B2B Marketing Agency Fits a Small Company? 8 Compared
      </Heading>
      <p className="mt-2 max-w-2xl text-sm leading-relaxed text-slate-300">
        Compare eight alphabetically presented London B2B agencies by public evidence, scope, buyer constraints, pricing questions and delivery ownership-not by a generic “best agency” claim.
      </p>
      <Link href={B2B_AGENCIES_GUIDE_PATH} className="mt-4 inline-flex text-sm font-semibold text-[#00D4AA] hover:text-teal-200">
        Read the London B2B agency comparison →
      </Link>
    </section>
  );
}
